<template>
  <div>
    <j-modal :visible.sync="visible" switchFullscreen :width="'90%'" @cancel="close()" :maskClosable="false"
      :destroyOnClose="true" onOk="handleOk" :footer="null">
      <div slot="title">
        <span>{{ unit.unitName }}</span>
        <a-divider v-if="unit.unitIntro" type="vertical"></a-divider>
        <a-icon type="question-circle" theme="twoTone" @click="showUnitInfo" />

        <a-divider v-if="unit.unitIntro" type="vertical"></a-divider>
        <a-button v-if="currentMedia.mediaType==10" v-has="'live:start'" @click="startLive(currentMedia.id)"
          type="danger" icon="play-circle">开播</a-button>

      </div>
      <a-spin v-if="loading" tip="加载中..." style="display: block; margin: 50px auto"></a-spin>
      <a-row v-else :gutter="24">
        <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
          <div class="video-area" id="media-content">
            <!-- 课程视频 -->
            <video v-if="videoUrl" oncontextmenu="return false;" controlsList="nodownload noremote footbar"
              :src="videoUrl" controls="true" @canplay="handleVideoInit" @play="handleVideoPlay"
              @timeupdate="handleVideoUpdate" @pause="handleVideoPause" @ended="handleVideoEnded"></video>
            <!-- 图片 -->
            <img v-if="imgUrl" :src="imgUrl" alt="" style="max-width: 100%;">
            <div v-show="pullUrl">
              <video id="player-container-id" preload="auto" playsinline webkit-playsinline></video>
            </div>

            <!-- 富文本 -->
            <a-icon v-if="mediaContent" class="download-media-content-icon" type="download"
              @click="downloadMediaContent" />
            <div ref="html2canvas" v-if="mediaContent" v-html="mediaContent"></div>
          </div>
        </a-col>
        <a-divider v-if="_isMobile()" />
        <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div class="unit-list">
            <a-timeline>
              <a-timeline-item color="blue" v-for="(media, index) in mediaList" :key="media.id">
                <a-icon v-if="media.mediaType == 5" slot="dot" type="edit" style="font-size: 16px" />
                <a-icon v-if="media.mediaType == 1" slot="dot" type="play-circle" style="font-size: 16px" />
                <a-icon v-if="media.mediaType == 3" slot="dot" type="snippets" style="font-size: 16px" />
                <a-row>
                  <a-col :span="media.isShare && userInfo.userIdentity == 2 ? 20: 24">
                    <a-collapse v-if="media.mediaPath.includes(',')" defaultActiveKey="1">
                      <a-collapse-panel key="1" :header="media.mediaName"
                        :style="{ backgroundColor: currentMediaIndex == index ? '#e2edff' : '#fafafa' }">
                        <a-button style="display: block; margin-bottom: 5px; width: 100%" size="small"
                          v-for="(val, i) in media.mediaPath_fileinfo" :key="i" @click="changeMedia(media, index, val.key)"
                          :type="currentMediaIndex == index && currentMediaFile == val.key ? 'primary' : 'default'">
                          {{ val.fileName }}<a-icon type="right" />
                        </a-button>
                      </a-collapse-panel>
                    </a-collapse>
                    <a-button v-else block @click="changeMedia(media, index, null)"
                      :type="currentMediaIndex == index ? 'primary' : 'default'">
                      {{ media.mediaName }}<a-icon type="right" />
                    </a-button>
                  </a-col>
                  <a-col :span="media.isShare && userInfo.userIdentity == 2?4:0">
                    <a-button v-if="media.isShare && userInfo.userIdentity == 2" type="link" @click="getShareCode(media.id)" style="margin-left: 10px;">
                      分享码
                    </a-button>
                  </a-col>
                </a-row>          
              </a-timeline-item>
            </a-timeline>
            <!-- <a-card v-if="unit.unitIntro" size="small" title="课程说明">
              <div v-html="unit.unitIntro ? unit.unitIntro.replace(/\n/g,'<br>') : ''"></div>
            </a-card> -->
          </div>
        </a-col>
      </a-row>
      <a-modal :width="'800px'" :visible="unitInfoVisible" :title="unit.unitName" :destroyOnClose="true" :footer="null"
        @cancel="unitInfoVisible = false">
        <div v-html="unit.unitIntro"></div>
      </a-modal>
    </j-modal>
    <!--确认购买 -->
    <template>
      <a-modal :visible="isModalVisible" title="分享码" @ok="handleCodeOk" @cancel="isModalVisible = false">
          <p>分享码为: {{ shareCode }}</p> 
          <p>有效期至: {{ validDate }}</p>
          <a-button type="primary" @click="updateCode" style="margin-right: 20px;">点击更新</a-button>
          <a-button @click="copyToClipboard">一键复制</a-button>
    </a-modal>
      <div>
        <a-modal title="购买课程" :visible="buyVisible" @cancel="buyHandleCancel" cancelText="关闭"
          wrapClassName="ant-modal-cust-warp custom-modal" style="top:5%;height: 85%;overflow-y: hidden" :footer="null">
          <p style="margin-bottom: 10px; text-align: center;">
            <a-icon type="exclamation-circle" style="color: orange; margin-right: 5px;"></a-icon>
            该课时在购买并参加该课程后才能观看
          </p>
          <div class="button-container">
            <a-button type="primary" @click="buyCoursePurchasePage(1)">
              ￥{{coursePrice}}单独购买
            </a-button>
            <span style="margin: 0 10px;"></span>
            <a-button type="default" @click="goToPurchasePage(2)" class="membership-button">
              开通会员
            </a-button>
          </div>
        </a-modal>
      </div>
    </template>
    <!--支付弹窗 -->
    <template>
      <div>
        <a-spin :spinning="createLoading" size="large">
          <a-modal title="扫码支付" :width="800" :visible="vipVisible" :confirmLoading="confirmLoading"
            @cancel="handleCancel" cancelText="关闭" @ok="handleOk" okText="我已完成支付?" wrapClassName="ant-modal-cust-warp"
            style="top:5%;height: 85%;overflow-y: hidden">

            <div class="payment-info">
              <span v-if="buyType == 2" class="vip-level">该课程需要的会员的等级：{{ vipLevel.vipName }}</span>
              <span v-if="buyType == 2" class="vip-price">价格：{{ vipLevel.price / 100 }}￥</span>
            </div>

            <div class="qr-code-container">
              <div class="qr-code-header">
                <img src="@/assets/wxlogo.png" class="wx-logo" />
              </div>
              <div class="qr-code-body">
                <canvas ref="qrcodeCanvas"></canvas>
                <div>请使用微信扫码二维码完成支付</div>
              </div>
            </div>
          </a-modal>
        </a-spin>
      </div>

    </template>
  </div>
</template>
<script>
// import '@/components/jeecg/JModal'
import {getAction, postAction} from '@/api/manage'
import { mixinDevice } from '@/utils/mixin.js'
import { getQiniuUrl, getQiniuFile } from '@/utils/qiniu.js'
import html2canvas from 'html2canvas'
import { saveAs } from 'file-saver'
import TCPlayer from 'tcplayer.js';
import 'tcplayer.js/dist/tcplayer.min.css';
import { Modal } from 'ant-design-vue';
var QRCode = require('qrcode')
var canvas = ''


export default {
  name: 'UnitViewModal',
  mixins: [mixinDevice],
  components:{
    // LiveControl
  },
  data() {
    return {
      visible: false,
      vipVisible: false,
      createLoading: false,
      buyVisible: false,
      isModalVisible: false,
      shareCode: '',
      validDate: '',
      mediaId: '',
      userInfo: {},
      vipLevel:{},
      payUrl: '',
      confirmLoading: false,
      loading: false,
      unitInfoVisible: false,
      unit: {},
      videoUrl: '',
      imgUrl: '',
      departId: '',
      pullUrl: '',
      pushUrl: '',
      streamName: '',
      mediaList: [],
      url: {
        unitMedia: '/teaching/teachingCourseUnit/unitMedia',
        studyLog: '/teaching/teachingStudyLog/study',
        unitStudyLog: '/teaching/teachingStudyLog/getUnitStudyLog',
      },
      mediaContent: '',
      currentMedia: {},
      currentMediaIndex: 0,
      currentMediaFile: 0,
      lastPlayTime: 0, //上次视频观看进度
      cacheDuration: 0, //等待提交的进度
      tcplayer: null,
      buyType: 0,
      coursePrice: 0, //课程价格
      courseId: '' //课程ID
    }
  },
  created() {
    this.departId = this.$route.query.departId
    this.userInfo = this.$store.state.user.info;
    console.log("角色")
    console.log(this.userInfo)
  },
  mounted() {
    // contextmenu 禁用右键菜单
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault()
    })
    // //禁止复制  selectstart
    // document.addEventListener('selectstart',function(e){
    //     e.preventDefault();
    // })
  },
  destroyed(){
    if(this.tcplayer){
        this.tcplayer.dispose()
    }
  },
  methods: {
    getQiniuUrl,
    getQiniuFile,
    startLive(id){
      this.$live({id}).startLive()
    },
    close(){
      if(this.tcplayer){
        this.tcplayer.dispose()
      }
      this.unit = {}
      this.videoUrl = ''
      this.imgUrl = ''
      this.pullUrl = ''
      this.mediaList = []
      this.visible = false
    },
    showUnitInfo() {
      this.unitInfoVisible = true
    },
    view(unit) {
      this.visible = true
      console.log(unit)
      this.currentMediaIndex = 0
      this.unit = unit
      this.getCourseMedia(unit.id)
      this.getUnitStudyLog()
    },
    getCourseMedia(unitId) {
      this.getCoursePrice()
      this.loading = true
      getAction(this.url.unitMedia, { id: unitId, departId: this.departId})
        .then((res) => {
          this.loading = false
          if (res.success) {
            this.mediaList = res.result
            for (let i = 0; i < this.mediaList.length; i++) {
              let item = this.mediaList[i]
              //自动选择第一个课件
              if ([1,2, 7, 10].includes(item.mediaType)) {
                this.changeMedia(item, i)
                break
              }
              console.log(item.mediaPath_fileinfo)
            }
          } else {
            this.$message.error(res.message)
            this.showPurchaseModal()
          }
        })
        .catch((e) => {
          console.log(e)
          this.loading = false
          let data = e.response.data
          if (data.message.includes('Token失效')) {
            this.$message.error('未登录')
          }
        })
    },
    //获取课程价格
    getCoursePrice() {
      getAction('/teaching/teachingCourse/queryById', { id: this.unit.courseId })
        .then((result) => {
          if (result.success) {
            this.courseId = result.result.id
            this.coursePrice = result.result.coursePrice / 100
          } else {
            this.$message.error(result.message)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    showPurchaseModal() {
      this.buyVisible = true
    },
    //开通会员
    goToPurchasePage(type) {
      this.buyType = type
      // 跳转到购买页面的逻辑
      console.log('去购买页面');
      // 显示全局 loading 状态
      this.loading = true;
      this.getVipLevelByCourseId();
    },
    //单独购买课程
    buyCoursePurchasePage(type) {
      this.buyType = type
      // 显示全局 loading 状态
      this.loading = true;
      this.getCourseByCourseId();
    },
    handleCancel () {
      this.closeVip()
    },
    handleOk () {
      this.closeVip()
      // 刷新页面
      window.location.reload();
    },
    closeVip () {
      this.$emit('close');
      this.vipVisible = false;
    },
    buyHandleCancel(){
      this.buyVisible = false
    },
    //根据课程id查询所需要的vip等级
    getVipLevelByCourseId() {
      getAction('/teaching/teachingVip/getVipByCourseId', { courseId: this.unit.courseId })
        .then((res) => {
          if (res.success) {
            this.vipLevel = res.result
            this.createVipOrder(this.vipLevel.id, this.vipLevel.price)
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //根据课程id查询所需要的价格
    getCourseByCourseId() {
          this.createCourseOrder(this.courseId, this.coursePrice)
    },

    //购买下单
    createVipOrder(id,price) {
      console.log(id)
      let params = {};
      params.vipId = id;
      params.payMode = 1;
      params.orderPrice = price;
      postAction("/teaching/teachingOrder/createVipOrder", params)
          .then((res) => {
            this.loading = false; // 请求成功，结束加载
            if (!res.success) {
              this.$message.error(res.message);
              return;
            }
            this.payUrl = res.message;
            console.log("=================="+this.payUrl);
            this.vipVisible = true;
            this.$nextTick(() => {
              this.generateQRCode();
            });

          })
          .catch((err) => {
            this.loading = false; // 请求成功，结束加载
            this.$message.error(err.message);
          });

    },
    createCourseOrder(id,price){
      console.log(id)
      let params = {};
      params.courseId = id;
      params.payMode = 1;
      params.orderPrice = price;
      postAction("/teaching/teachingOrder/createCourseOrder", params)
          .then((res) => {
            this.loading = false; // 请求成功，结束加载
            if (!res.success) {
              this.$message.error(res.message);
              return;
            }
            this.payUrl = res.message;
            console.log("=================="+this.payUrl);
            this.vipVisible = true;
            this.$nextTick(() => {
              this.generateQRCode();
            });

          })
          .catch((err) => {
            this.loading = false; // 请求成功，结束加载
            this.$message.error(err.message);
          });
    },
    //生成二维码
    generateQRCode() {
      const canvas = this.$refs.qrcodeCanvas;
      QRCode.toCanvas(canvas, this.payUrl, { width: 200 }, function (error) {
        if (error) console.error(error);
        console.log('二维码生成成功');
      });
    },
    changeMedia(media, index, mediaFile) {
      if(!mediaFile && media.mediaPath && media.mediaPath_fileinfo && media.mediaPath_fileinfo[0]){
        mediaFile = media.mediaPath_fileinfo[0].key
      }
      if([1,2,7,10].includes(media.mediaType)){
        this.mediaContent = ''
        this.videoUrl = ''
        this.pullUrl = ''
        this.imgUrl =''
        if(this.pullUrl && this.tcplayer){
          this.tcplayer.ready(function(){
              this.tcplayer.pause()
          })
        }
      }
      this.currentMedia = media
      this.currentMediaIndex = index
      this.currentMediaFile = mediaFile
      let url
      if (media.mediaPath.includes(',')) {
        if (mediaFile) {
          url = this.searchObjByKey(media.mediaPath_fileinfo, 'key', mediaFile)['url']
        } else {
          url = media.mediaPath_fileinfo[0]['url']
          this.currentMediaFile = media.mediaPath_fileinfo[0]['key']
        }
      } else {
        url = media.mediaPath_url
      }

      console.log('changeMedia', media, index, mediaFile, url)
      switch (media.mediaType) {
        case 1: //教学视频
          if (url.endsWith('.mp4')) {
            this.videoUrl = url;
          } else {
              window.open(url, '_blank'); // 非 mp4 文件执行 window.open 打开新窗口
            }
          break
        case 2: //图片
          this.imgUrl = url
          break
        case 3: //课堂练习
        case 5: //课后作业
          this.handleViewCode(media, mediaFile)
          break
        case 6: //PPT
          // if(media.mediaPath_url.endsWith('ppt') || media.mediaPath_url.endsWith('pptx') ){
          window.open(`/fileView?url=` + encodeURIComponent(btoa(url)))
          // }else{
          // window.open(media.mediaPath_url)
          // }
          break
        case 7: //富文本
          this.mediaContent = media.mediaContent
          this.studyLog(0, 0, true)
          break
        case 8: //OJ
          window.open('/onlinecode/index.html?questionId=' + media.questionId)
          break
        case 10: //直播
          this.getLiveDetail()
          break
        default:
          window.open(url)
      }
    },
    //获取分享码
    getShareCode(mediaId){
      console.log(mediaId) 
        this.mediaId = mediaId
        let params = {mediaId:mediaId};
        getAction("/teaching/teachingCourseMedia/getShareCode",params).then((res)=>{
            if (res.success && res.result){
               console.res
               this.shareCode = res.result.sharingCode
               this.validDate = res.result.validDate
            }else{
              this.shareCode = ''
               this.validDate = ''
            }
          });
        this.isModalVisible = true;
        //TODO
    },
      //更新分享码
      updateCode(){
        let params = {mediaId:this.mediaId};
        getAction("/teaching/teachingCourseMedia/genShareCode",params).then((res)=>{
            if (res.success){
               console.res
               this.shareCode = res.result.sharingCode
               this.validDate = res.result.validDate
            }
          });
      },
      handleCodeOk() {
        this.isModalVisible = false;
      },
      //一键复制
      copyToClipboard() {
        navigator.clipboard.writeText(this.shareCode).then(() => {
          this.$message.success('复制成功');
        }, (err) => {
          this.$message.error('复制成功');
          console.error('复制成功: ', err);
        });
      },
    getLiveDetail(){
      let that = this
      getAction('/teaching/broadcast/getRoomDetail?mediaId=' + this.currentMedia.id).then(res=>{
        if(!res.success){
          this.$message.error(res.message)
          return
        }
        this.pullUrl = res.result.pullURL
        this.pushUrl = res.result.pushURL
        this.streamName = res.result.streamName
        console.log('tcplayerUrl', this.pullUrl);
        this.setVideoSrc(that.pullUrl)
      })
    },
    setVideoSrc(url){
      let that = this
      if(this.tcplayer){
          this.tcplayer.ready(function(){
            that.tcplayer.src(url)
          })
        }else{
          this.tcplayer = TCPlayer('player-container-id', {
            sources: [{
              src: url, // 播放地址
              autoplay: true
            }],
            controlBar:{
            }
          });
          this.tcplayer.on('error', function(error){
            console.log('tcplayerError', error.data.code, error);
            switch(error.data.code){
            }
          })
          this.tcplayer.on('webrtcevent', function(event) {
              // 从回调参数 event 中获取事件状态码及相关数据
              // https://cloud.tencent.com/document/product/881/30820
              console.log('webrtcevent', event.data.code, event);
              switch(event.data.code){
                case 1001: //开始拉流 
                case 1002: //已经链接服务器
                case 1003: //视频播放开始
                case 1004: //停止拉流
                case 1005: //链接服务器失败，自动重连
                case 1006: //拉流数据为空
                case 1009: //拉流卡顿等待缓冲
                case 1010: //拉流卡顿结束↩️播放
              }
          });
        }
    },
    searchObjByKey(list, key, value) {
      for (let i = 0; i < list.length; i++) {
        if (list[i][key] == value) {
          return list[i]
        }
      }
      return {}
    },
    handleVideoInit() {
      console.log('video init')
      this.studyLog(0, 0, false)
    },
    handleVideoPlay() {
      console.log('play')
    },
    handleVideoPause() {
      console.log('pause')
    },
    handleVideoEnded(e) {
      console.log('ended')
      let duration = e.target.duration
      this.currentMedia.finished = true
      this.studyLog(parseInt(duration), parseInt(this.cacheDuration), true)
    },
    handleVideoUpdate(e) {
      let rate = 10 //日志记录频率
      let currentTime = e.target.currentTime
      let duration = e.target.duration
      this.cacheDuration += currentTime - this.lastPlayTime
      this.lastPlayTime = currentTime
      //播放10秒记录日志
      if (this.cacheDuration > rate) {
        this.studyLog(parseInt(duration), parseInt(this.cacheDuration), false)
        this.cacheDuration = 0
      }
    },
    //记录学习日志
    studyLog(videoTime, duration, finished) {
      getAction(this.url.studyLog, {
        mediaId: this.currentMedia.id,
        mediaType: this.currentMedia.mediaType,
        unitId: this.unit.id,
        courseId: this.unit.courseId,
        videoTime,
        duration,
        finished,
      }).then((res) => {})
    },
    getUnitStudyLog() {
      getAction(this.url.unitStudyLog, { courseId: this.unit.courseId, unitId: this.unit.id })
    },
    handleViewCode(media, mediaFile) {
      switch (media.codeType) {
        case 1:
          window.open(
            '/scratch3/index.html?scene=twl&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 2:
          window.open(
            '/scratch3/index.html?scene=twl&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 3:
          return window.open('/scratchjr/editor.html?mode=edit&filepath=' + media.mediaPath_url.split(',')[mediaFile])
          break
        case 4:
          return window.open(
            '/onlinecode/index.html?lang=turtle&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 5:
          return window.open(
            '/onlinecode/index.html?lang=python&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 6:
          return window.open(
            '/onlinecode/index.html?lang=c&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 7:
          return window.open(
            '/onlinecode/index.html?lang=cpp&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 8:
          return window.open(
            '/onlinecode/index.html?lang=java&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        default:
          window.open(this.getQiniuFile(media.mediaPath_url))
      }
    },
    downloadMediaContent() {
      let that = this
      let contentDom = document.getElementById('media-content')
      contentDom.scrollTop = 0
      html2canvas(this.$refs.html2canvas, {
        backgroundColor: 'white',
        useCORS: true, // 解决文件跨域问题
        height: contentDom.scrollHeight,
        windowHeight: contentDom.scrollHeight,
      }).then((canvas) => {
        const url = canvas.toDataURL('image/png') // 生成的图片
        saveAs(url, that.unit.unitName + '-' + that.currentMedia.mediaName + '.png')
      })
    },
  },
}
</script>
<style lang="less" scoped>
.video-area {
  .tcplayer {
    width: 100%;
    min-height: 480px;
  }
  max-height: 700px;
  min-height: 480px;
  overflow: auto;
  video {
    width: 100%;
    min-height: 480px;
  }
}
.unit-list {
  vertical-align: top;
  padding: 10px;
  margin: 0 20px;
  max-height: 700px;
  overflow-y: auto;
  /deep/.ant-btn {
    text-align: left;
  }
}

.download-media-content-icon {
  opacity: 1;
  color: black;
  font-size: 24px;
  line-height: 24px;
  position: absolute;
  top: 2px;
  right: 24px;
  z-index: 9;
  cursor: pointer;
  transition: opacity 0.3s;
}
.payment-info {
  margin: 16px 0;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.vip-level,
.vip-price {
  display: block;
  margin-bottom: 8px;
}

.qr-code-container {
  border: 1px solid #f5f5f5;
  height: 300px;
  width: 70%;
  margin: 0 auto;
  padding: 16px;
  box-sizing: border-box;
}

.qr-code-header {
  text-align: center;
  margin-bottom: 16px;
}

.wx-logo {
  width: 100px;
  height: 25px;
}

.qr-code-body {
  text-align: center;
}
.custom-modal {
    position: relative; /* 使模态框的定位上下文为相对定位 */
    top: 5%;
    height: 85%;
    overflow-y: hidden;
  }
  .modal-body {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between; /* 将内容区域分布在顶部和底部 */
  }
  .button-container {
    display: flex;
    justify-content: center; /* 按钮容器水平居中 */
    margin-bottom: 16px; /* 距离底部的距离 */
  }
  .membership-button {
    color: orange;
  }
</style>
